const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
        // Fill me out
        },
        appearances: {
            default: {
                default: true,
            },
        },
        variantGroups: {},
        states: {},
    },
    appearances: {
        default: {
            mapping: {},
            variantGroups: {},
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAContextMenu.theme.alucio.js.map